import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchComptencyData,
} from "../../services/hiringAssessmentService";
import "react-vertical-timeline-component/style.min.css";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import check_green from "../../assets/images/icon/check-green.svg";
import cross_icon from "../../assets/images/icon/cross-icon.svg";
import time_slot from "../../assets/images/time-slot-card.webp";
import Select from "react-select";

import {
  CircularProgressbar,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { decryptDataFromArray } from "helpers/EncDec";
import { toast } from "react-toastify";

import { getUserInfo } from "helpers/authHelper";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { GetEmployeeReferralList } from "services/EmployeeReferralService";
import { useTranslation } from "react-i18next";
import { set } from "lodash";


const ModalView = ({ isOpen, onClose, resumeUrl, fileType }) => {
  if (!isOpen) return null;

  // const viewerUrl = getViewerUrl(resumeUrl, fileType);
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <iframe src={resumeUrl} title="Document Viewer" />
      </div>
    </div>
  );
};

const ViewDetails = () => {
  const { t } = useTranslation();
  const [error, setError] = useState([]);
  const [msg, setMsg] = useState("");
  const { appl_id } = useParams();
  const [candidateDetails, setCandidateDetails] = useState({});
  const [competencyData, setCompetencyData] = useState({});
  const [assessmentScore, setAssessmentScore] = useState({});
  const [screeningTestScore, setScreeningTestScore] = useState({
    competencyScores: 0,
    overallPercentage: 0,
    totalMarks: 0,
    scoredMarks: 0,
    totalQuestions: 0,
  });
  const [santimentDetails, setSantimentDetails] = useState({});
  const [videoUrl, setVideoUrl] = useState();
  const [trackerValues, setTrackerValues] = useState([]);
  const [timelineUpdates, setTimelineUpdates] = useState([]);
  const [documentData, setDocumentData] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [noteString, setNoteString] = useState("");
  const [allNotes, setAllNotes] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const resumeUrl = candidateDetails?.job_user?.resume; // URL of the document
  const id = candidateDetails?.user_id;
  const fileType = resumeUrl?.split(".")?.pop() || ""; // Basic way to determine file type from URL

  const [loading, setLoading] = useState(false); // To handle loading state
  const [resumeGenerated, setResumeGenerated] = useState(false);
  const isCVBuild = candidateDetails?.job_user?.isResumeBuilt;
  const generatedResumeUrl = candidateDetails?.job_user?.resume_filename;
  const [url, setResumeUrl] = useState(null);
  const [employeeReferralList, setEmployeeReferralList] = useState([]);
  const [referred, setReferred] = useState({});

  // Communication Logs changes
  const [communicationLogs, setCommunicationLogs] = useState([]);
  const [feedbackData, setFeedbackData] = useState({});

  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

  const userInfo = getUserInfo();

  // Edit User States
  const [editModal, setEditModal] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [hiringSouces, setHiringSources] = useState([]);
  const [genderData, setGenders] = useState([]);
  const [errors, setErrors] = useState({});

  const closeVideoPopup = () => {
    setVideoUrl("");
  };
  const fixedProgressValues = [20, 40, 60, 80, 100];
  const [progressIndex, setProgressIndex] = useState(0);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  
  const { allFeedbacks, averageScore, ratingCounts } = feedbackData || {};
  useEffect(() => {

    // Fetch competency Data
    
      fetchComptencyData(lang_id)
        .then(res => {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);

          if (responseData?.status) {
            const comptArr = {};

            Object.entries(responseData?.data).forEach(
              ([c_key, c_value], c) => {
                comptArr[c_value.id] = c_value.name;
              }
            );

            setCompetencyData(comptArr);
          }
        })
        .catch(error => {
          setError("No data Available");
        });
    
  }, [appl_id]);

  // Function to fetch employee referral list and check for matching email
  const fetchEmployeeReferralList = async () => {
    try {
      const res = await GetEmployeeReferralList();
      if (res?.status === 200) {
        const employeeList = res?.data?.data || [];
        setEmployeeReferralList(employeeList);

        // If candidate details are already available, check for email match
        if (candidateDetails?.email_id) {
          // console.log(candidateDetails?.email_id);
          // console.log("Employee List:", employeeList);
          const matchingEmployee = employeeList.find(
            emp => emp.candidate_email === candidateDetails?.email_id
          );
          // console.log(matchingEmployee);
          if (matchingEmployee) {
            setReferred(matchingEmployee);
          }
        }
      } else {
        toast.error(t(`View Details.No data available`));
      }
    } catch (err) {
      toast.error(t(`View Details.Error fetching employee referral list`));
    }
  };

  // Fetch employee referral list only when `candidateDetails` changes
  useEffect(() => {
    if (candidateDetails?.email_id) {
      fetchEmployeeReferralList();
    }
  }, [candidateDetails]); // Triggered only when `candidateDetails` changes

  // useEffect(() => {
  //   if (candidateDetails.hiring_assessments?.questions_value) {
  //     const questions_value_obj = JSON.parse(candidateDetails.hiring_assessments.questions_value);
  //     const questIds = questions_value_obj.quest_ids;

  //     const Arr = [];
  //     let ArrTotalCompt = 0;
  //     let totalSize = 0;

  //     const Arr1 = {
  //       option1: 'weightage1',
  //       option2: 'weightage2',
  //       option3: 'weightage3',
  //       option4: 'weightage4',
  //     };

  //     Object.entries(questIds).forEach(([key, value], i) => {
  //       var size = Object.keys(value).length;
  //       totalSize += Object.keys(value).length;

  //       if (!Arr[key]) {
  //         Arr[key] = { sum: 0 };
  //       }

  //       Object.entries(value).forEach(([key1, value1], j) => {
  //         Arr[key].sum += parseInt(value1[Arr1[value1.answerValue]], 10);
  //       });

  //       ArrTotalCompt += Arr[key].sum;
  //       Arr[key].per = Math.round((Arr[key].sum / (size * 4)) * 100);
  //     });

  //     Arr.compt_avg_per = Math.round((ArrTotalCompt / (totalSize * 4)) * 100);
  //     setAssessmentScore(Arr);
  //     console.log('setAssessmentScore::',Arr);
  //   }
  // }, [candidateDetails]);

  const [questionBehaviourList, setQuestionBehaviourList] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (candidateDetails.hiring_assessments?.questions_value) {
      const questions_value_obj = JSON.parse(
        candidateDetails.hiring_assessments.questions_value
      );
      const questIds = questions_value_obj.quest_ids;

      const Arr = [];
      const Arr_behav = [];
      let ArrTotalCompt = 0;
      let totalSize = 0;
      let ques_behav_id_arr = [];
      let ques_behav_ids = [];

      const Arr1 = {
        option1: "weightage1",
        option2: "weightage2",
        option3: "weightage3",
        option4: "weightage4",
      };
      let sum_weightage = "";

      Object.entries(questIds).forEach(([key, value], i) => {
        //console.log('key:166',key);
        // console.log('key:167',value);

        var size = Object.keys(value).length;
        totalSize += Object.keys(value).length;

        if (!Arr[key]) {
          Arr[key] = { sum: 0 };
        }
        if (!Arr[key]) {
          Arr[key] = { behav_sum: 0 };
        }

        Object.entries(value).forEach(([key1, value1], j) => {
          Arr[key].sum += parseInt(value1[Arr1[value1.answerValue]], 10);
          sum_weightage += parseInt(value1[Arr1[value1.answerValue]], 10);
          ques_behav_id_arr.push(value1.ques_behav_id);
          ques_behav_ids = value1.ques_behav_id; // [1,2,3]

       
        });

        ArrTotalCompt += Arr[key].sum;
        Arr[key].per = Math.round((Arr[key].sum / (size * 2)) * 100);
      });
    
      const compt_avg_per =
        totalSize > 0 ? Math.round((ArrTotalCompt / (totalSize * 2)) * 100) : 0;
      Arr.compt_avg_per = isNaN(compt_avg_per) ? 0 : compt_avg_per;

      setAssessmentScore(Arr);
    }
  }, [candidateDetails]);
  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };



  //arrow-table
  const [isFocused, setIsFocused] = useState(false);

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    if (window.innerWidth >= 1400) {
      moveDistance = 20; // For 1400px and wider
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = 20; // For 1280px to 1399px
    } else if (window.innerWidth < 1280) {
      moveDistance = 50; // For less than 1280px
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    if (window.innerWidth >= 1400) {
      moveDistance = 100; // For 1400px and wider
    } else if (window.innerWidth >= 1280) {
      moveDistance = 300; // For 1280px to 1399px
    } else if (window.innerWidth >= 1152) {
      moveDistance = 350; // For 1152px to 1279px
    } else {
      moveDistance = 100; // For less than 1152px
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const [activeTab, setActiveTab] = useState("application");

  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  // Function to create options based on trackerValues
  const createOptions = candidateDetails => {
    const hiringAssessments = candidateDetails?.hiring_assessments || [];
    return hiringAssessments.map(assessment => ({
      value: assessment.interview_type_id, // Use interview_type_id as the option value
      label: assessment.interview_title, // Use interview_title as the option label
    }));
  };

  // Generate options dynamically
  const options = createOptions(candidateDetails);

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption);
  };

  const assessments = candidateDetails?.hiring_assessments || [];
  let parsedQuestions = {};

  // Find the selected assessment based on the selected option
  const selectedAssessment = assessments.find(
    assessment => assessment.interview_type_id === selectedOption?.value
  );

  // Parse the `questions_value` field to get the questions if a valid assessment is found
  if (selectedAssessment?.questions_value) {
    parsedQuestions = JSON.parse(selectedAssessment.questions_value);
  }

  let questCounter = 1;

  const getWeightageFromOption = question => {
    if (question.answer === "option1") return Number(question.weightage1);
    else if (question.answer === "option2") return Number(question.weightage2);
    else if (question.answer === "option3") return Number(question.weightage3);
    else if (question.answer === "option4") return Number(question.weightage4);
  };

  const calculateCompetencyScores = () => {
    const scores = {};
    let overallTotalWeightage = 0;
    let overallAnsweredWeightage = 0;
    let totalQuestions = 0;

    if (parsedQuestions?.quest_ids) {
      Object.entries(parsedQuestions.quest_ids).forEach(
        ([compId, questions]) => {
          let totalWeightage = 0;
          let answeredWeightage = 0;
          Object.values(questions)?.forEach((elem, ind) => {
            totalQuestions++;
            totalWeightage += Math.max(
              elem.weightage1,
              elem.weightage2,
              elem.weightage3,
              elem.weightage4
            );
            if (
              elem.answer === elem.answerValue ||
              elem[elem.answer] === elem.answerValue
            ) {
              answeredWeightage += getWeightageFromOption(elem);
            }
          });
          overallTotalWeightage += Number(totalWeightage);
          overallAnsweredWeightage += Number(answeredWeightage);

          const competencyScore = Math.round(
            (answeredWeightage / totalWeightage) * 100
          );

          scores[compId] = {
            score: competencyScore,
            title: competencyData[compId],
          };
        }
      );
    }
    const overallPercentage =
      (overallAnsweredWeightage / overallTotalWeightage) * 100;

    return {
      competencyScores: scores,
      overallPercentage: overallPercentage,
      totalMarks: overallTotalWeightage,
      scoredMarks: overallAnsweredWeightage,
      totalQuestions: totalQuestions,
    };
  };

  // Calculate and set the competency scores
  useEffect(() => {
    const scores = calculateCompetencyScores();
    setScreeningTestScore(scores);
  }, [selectedOption]);

  const printRef = useRef(); // Create a ref to hold the content to print

  const handlePrint = () => {
    const contentToPrint = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    // Set the page content to the content you want to print
    document.body.innerHTML = contentToPrint;

    window.print();

    // After printing, restore the original content of the page
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload to reset any lost state (optional)
  };

  //   const printWindow = window.open("", "_blank"); // Open a new window
  //   // printWindow.document.write(`
  //   //   <html>
  //   //     <head>
  //   //       <title>Print Competency Questions</title>
  //   //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"> <!-- Optional: Link Bootstrap CSS -->
  //   //       <style>
  //   //         body { font-family: Arial, sans-serif; padding: 20px; }
  //   //         h1 { text-align: center; }
  //   //         .competency-question { margin-bottom: 20px; }
  //   //         .question { margin: 10px 0; }
  //   //         .answer { margin-left: 20px; }
  //   //       </style>
  //   //     </head>
  //   //     <body>
  //   //       <h1>Candidate Responses</h1>
  //   //       <div>${printRef.current.innerHTML}</div> <!-- Insert the HTML to print -->
  //   //     </body>
  //   //   </html>
  //   // `);
  //   // printWindow.document.close();
  //   // printWindow.print();

  //   const printContent = printRef.current;
  //   const win = window.open('', '', 'width=900,height=650');
  //   win.document.write(printContent.outerHTML);
  //   win.document.close();
  //   win.focus();
  //   win.print();
  //   win.close();
  // };
  return (
    <>
      <div className="outerTab-box-wrapper below-vacancy">
       
        <div className="view-details-cards">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>

          <ul
            className="mb-3 nav nav-tabs"
            ref={tabWrapperRef}
            style={{ transition: "transform 0.3s" }}
          >
           
            <li className="nav-item">
              <button
                type="button"
                onClick={() => handleTabClick("screening")}
                className={`nav-link ${
                  activeTab === "screening" ? "active" : ""
                }`}
              >
                {t(`View Details.Screening Test Analysis`)}
              </button>
            </li>
           
          </ul>

          <div className="tab-content">
           

       
            {activeTab === "screening" && (
              <div>
                <div className="row mt-1" ref={printRef}>
                  <div className="col-md-12 col-lg-12 paragrcontent-anays CompetencyScore drodpwoan">
                    <div className="competency-score-card">
                      <h5>{t(`View Details.Test Result`)}</h5>

                      <div
                        title={
                          selectedOption?.label ||
                          `${t(`View Details.Test Result`)}`
                        }
                      >
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={options}
                          placeholder={t(`View Details.Select Test`)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Competency Score Section */}
                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore viewdetailsca">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      <>
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <h2 className="h3 mb-1">
                            {t(`View Details.Competency Score`)}
                          </h2>
                        </div>
                        <div className="mb-2  view-details-menu  Screentest7">
                          {Object.entries(
                            screeningTestScore?.competencyScores
                          ).map(([compId, { score, title }]) => (
                            <div className="key-titile" key={compId}>
                              <div className="text-center">
                                <div className="tile-names">
                                  <div className="title-name pb-2">{title}</div>
                                </div>
                                <div className="score-details-section">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "130px",
                                    }}
                                  >
                                    <div
                                      className="circleprogress"
                                      style={{ width: 130, height: 130 }}
                                    >
                                      <CircularProgressbar
                                        value={score}
                                        maxValue={100}
                                        text={`${score}%`}
                                        strokeWidth={8}
                                        styles={buildStyles({
                                          textColor: "#000",
                                          pathColor: "#ff0000", // Red color for the progress bar
                                          trailColor: "#d6d6d6",
                                        })}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="competency-scores score-cards-flex Screentest7">
                         
                        </div>
                      </>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-6 paragrcontent-anays CompetencyScore">
                    <div className="cards-section cadidate-details cardshadow paragrcontent mt-2">
                      {/* <h2 className="h3 mb-1"></h2> */}
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h2 className="h3 mb-1">
                          {t(`View Details.Screen Test`)}
                        </h2>
                      </div>

                      <div className="card-table-details tabel-application table-responsive  Screentest7">
                        {/* Circular Progress Bar for Test Score */}
                        {screeningTestScore?.totalQuestions > 0 && (
                          <div className="score-details-section">
                            {/* <h4 className="h4 mb-2">Screen test</h4> */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "130px",
                              }}
                            >
                              <div
                                className="circleprogress"
                                style={{ width: 130, height: 130 }}
                              >
                                <CircularProgressbar
                                  value={screeningTestScore?.overallPercentage}
                                  text={`${Math.round(
                                    screeningTestScore?.overallPercentage
                                  )}%`}
                                  styles={buildStyles({
                                    textColor: "#000",
                                    pathColor: "#ff0000", // Red color for the progress bar
                                    trailColor: "#d6d6d6",
                                  })}
                                />
                              </div>
                            </div>
                            <div
                              className="score-summary mt-2"
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                gap: "5px",
                                flexWrap: "wrap",
                              }}
                            >
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Questions`)}:{" "}
                                {screeningTestScore?.totalQuestions}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Total Marks`)}:{" "}
                                {screeningTestScore?.totalMarks}
                              </p>
                              <p style={{ margin: 0 }}>
                                {t(`View Details.Marks Obtained`)}:{" "}
                                {screeningTestScore?.scoredMarks}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-8 co-md-12">
                    <div className="competancy-question-card">
                      <h5>{t(`View Details.Competency Question`)}</h5>

                      {parsedQuestions?.quest_ids &&
                        Object.entries(parsedQuestions.quest_ids).map(
                          ([compId, questions], compIndex) => {
                            return Object.entries(questions).map(
                              ([questionId, questionData], quesIndex) => {
                                return (
                                  <div
                                    className="competenacy-tracker-card"
                                    key={questionData.id}
                                  >
                                    <p>
                                      <div className="dotse"></div>
                                      {t(`View Details.Question`)}{" "}
                                      {questCounter++}{" "}
                                      <span>({competencyData[compId]})</span>
                                      <span>
                                        {Math.max(
                                          questionData.weightage1,
                                          questionData.weightage2,
                                          questionData.weightage3,
                                          questionData.weightage4
                                        )}{" "}
                                        Marks
                                      </span>
                                    </p>
                                    <h3>{questionData.question}</h3>

                                    <div className="competacy-answear-card">
                                      <div className="competacy-answear-card-content">
                                        <p>
                                          {[
                                            "option1",
                                            "option2",
                                            "option3",
                                            "option4",
                                          ].includes(questionData.answerValue)
                                            ? `${t(
                                                `View Details.Your answer`
                                              )}: ${
                                                questionData[
                                                  questionData.answerValue
                                                ]
                                              }`
                                            : questionData.answerValue
                                            ? `${t(
                                                `View Details.Your answer`
                                              )}: ${questionData.answerValue}`
                                            : t(
                                                `View Details.No answer provided`
                                              )}
                                        </p>
                                      </div>
                                      <span>
                                        <img
                                          src={
                                            questionData.answerValue ===
                                              questionData.answer ||
                                            questionData.answerValue ===
                                              questionData[questionData.answer]
                                              ? check_green
                                              : cross_icon
                                          }
                                          alt={
                                            questionData.answerValue ===
                                            questionData.answer
                                              ? "check"
                                              : "cross"
                                          }
                                        />
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            );
                          }
                        )}
                    </div>
                  </div>

          
                </div>
              </div>
            )}

          </div>
        </div>

      </div>
    </>
  );
};

export default ViewDetails;
